
export default function TeamSection() {
  const team = [
    {
      name: "Sarah Dubois",
      role: "Fondatrice & CEO",
      image: "https://public.readdy.ai/ai/img_res/c691a08704bda1d888289f0431518696.jpg",
      description: "Ancienne coach certifiée ICF avec 15 ans d'expérience dans le développement personnel."
    },
    {
      name: "Marc Leroy",
      role: "Directeur Technique",
      image: "https://readdy.ai/api/search-image?query=Professional%20male%20CTO%20in%20his%2030s%2C%20technology%20leader%2C%20modern%20tech%20office%20background%2C%20natural%20lighting%2C%20confident%20and%20innovative%20expression%2C%20casual%20business%20attire&width=400&height=400&seq=team2&orientation=squarish",
      description: "Expert en technologie avec une passion pour l'innovation dans le domaine du coaching digital."
    },
    {
      name: "Julie Martin",
      role: "Responsable Qualité",
      image: "https://readdy.ai/api/search-image?query=Professional%20female%20quality%20manager%20in%20her%2030s%2C%20business%20attire%2C%20modern%20office%20background%2C%20natural%20lighting%2C%20detail-oriented%20and%20professional%20expression&width=400&height=400&seq=team3&orientation=squarish",
      description: "Psychologue de formation, elle supervise la qualité de nos programmes de coaching."
    },
    {
      name: "Antoine Rousseau",
      role: "Directeur Commercial",
      image: "https://readdy.ai/api/search-image?query=Professional%20male%20sales%20director%20in%20his%2040s%2C%20business%20suit%2C%20modern%20corporate%20office%20background%2C%20natural%20lighting%2C%20charismatic%20and%20engaging%20expression&width=400&height=400&seq=team4&orientation=squarish",
      description: "Spécialiste en développement commercial avec une expertise dans les services B2C."
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Notre Équipe
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Une équipe passionnée et expérimentée, dédiée à votre réussite
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {team.map((member, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden">
              <img 
                src={member.image} 
                alt={member.name}
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-1">{member.name}</h3>
                <p className="text-blue-600 font-medium mb-3">{member.role}</p>
                <p className="text-gray-600 text-sm">{member.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
